
import { useNavigate } from 'react-router-dom';
import UTILS from '../../utils/commons'
const TenderItem = ( { tender, idx } ) => {
    const navigate = useNavigate();
    return <div key={tender.id} className={`grid md:grid-cols-6 ${( idx + 1 ) % 2 === 0 ? 'bg-gray-50' : ''} p-3 border-t border-gray-100 cursor-pointer text-gray-700 hover:bg-gray-100`} onClick={() => navigate( `/tenders/view/${tender.id}`, { replace: false } )}>
        <span>{UTILS.formatDate( tender.createdAt )}</span>
        <span>{tender.title}</span>
        <span>{tender.organisation}</span>
        <span className='font-medium'>{UTILS.thousandSeparator( tender.tenderedAmount )}</span>
        <span>{UTILS.thousandSeparator( tender.expenses.reduce( ( sum, ex ) => sum + Number( ex.amount ), 0 ) )}</span>
        <span>{UTILS.tenderStatusBadge( tender.status )}</span>
    </div>
}
export default TenderItem;